import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { AlertsPage } from './pages/AlertsPage';
import { ALERT_TABS } from './alerts.paths';

export const ALERT_ROUTES: RouteObject[] = recordTabRoutes('alerts', ALERT_TABS, (tab) => <AlertsPage tab={tab} />);
